export default __webpack_public_path__ + "static/media/reitangruppen-logo_gold2.c26f298e.svg";